export const messages = {
  home: 'Inicio',
  login: 'Iniciar Sesión',
  logout: 'Cerrar Sesión',
  unauthorized_page_message: 'No posee acceso a este servicio',
  customers_prividers: 'Clientes y proveedores',
  bills: 'Facturas',
  configuration: 'Configuración',
  upload_bills: 'Subir Facturas',
  upload: 'Subir',
  client_portal: 'Portal del Cliente',
  provider_portal: 'Portal del Proveedor',
  welcome_edx_inbox: 'Bienvenidos a EDX INBOX',
  customers_portal: 'Portal clientes',
  password: 'Contraseña',
  change_password: 'Cambiar contraseña',
  email: 'Correo',
  remember_me: 'Mantener la sesión abierta',
  forgot_password: '¿Has olvidado tu contraseña?',
  payment_complements: 'Complementos de pago',
  reports: 'Reportes',
  general_config: 'Ajustes generales',
  add_user: 'Añadir usuario',
  validations: 'Validaciones',
  my_account: 'Mi cuenta',
  my_subscription: 'Mi suscripción',
  welcome_to_edx_inbox: 'Bienvenido a EDX INBOX',
  new_bills: 'Facturas recientes',
  go_to_bills: 'Ir a facturas',
  purchase_orders: 'Órdenes de compra',
  purchase_order: 'Órden de compra',
  permissions_management: 'Gestión de Permisos',
  providers: 'Proveedores',
  provider: 'Proveedor',
  providers_management: 'Gestión de Proveedores',
  users_registration: 'Alta de usuarios',
  filters: 'Filtros',
  date: 'Fecha',
  apply: 'Aplicar',
  actions: 'Acciones',
  folio: 'Folio',
  serie: 'Serie',
  issuing_rfc: 'RFC Emisor',
  receiver_rfc: 'RFC Receptor',
  state: 'Estado',
  total: 'Total',
  uuid_fiscal_folio: 'UUID Folio Fiscal',
  short_months_comma_separate: 'Ene,Feb,Mar,Abr,May,Jun,Jul,Ago,Sep,Oct,Nov,Dic',
  long_months_comma_separate:
    'Enero,Febrero,Marzo,Abril,Mayo,Junio,Julio,Agosto,Septiembre,Octubre,Noviembre,Diciembre',
  total_amount_in_invoices: 'Monto total en facturas',
  documents_by_status: 'Documentos por estado',
  share: 'Compartir',
  tax_type: 'Tipo de Impuesto',
  transfer: 'Traslado',
  retention: 'Retención',
  terms_and_conditions: 'Términos y condiciones',
  cfdis: 'CFDIs',
  upload_documents: 'Subir documentos',
  upload_payment_complements: 'Subir complementos de pago',
  cfdis_orders_purchase: 'CFDIs / Órdenes de compra',
  cfdis_received: 'CFDIs recibidos',
  cfdis_with_error: 'CFDIs con error',
  completed_oc: 'OC completadas',
  not_attended_oc: 'OC no atendidas',
  partial_attended_oc: 'OC parcialmente atendidas',
  new: 'Nuevo',
  import: 'Importar',
  export: 'Exportar',
  document_number: 'Número de documento',
  store: 'Almacén',
  number: 'Número',
  area: 'Área',
  areas: 'Áreas',
  rfc: 'RFC',
  rfcs: 'RFCs',
  company_name: 'Nombre de la compañía',
  company_type: 'Tipo de compañía',
  area_management: 'Gestión de Áreas',
  profile_management: 'Gestión de Perfiles',
  user_management: 'Gestión de Usuarios',
  profile_name: 'Nombre del perfil',
  amount_of_users: 'Número de usuarios',
  amount_of_rules: 'Número de reglas',
  name: 'Nombre',
  admin: 'Administrador',
  profile: 'Perfil',
  email_title: 'Correo electrónico',
  payment_complement_list: 'Listado de complementos de pago',
  cfdis_list: 'Listado de CFDIs',
  filter_search: 'Filtrar búsqueda',
  update: 'Actualizar',
  close: 'Cerrar',
  nothing_selected: 'Nada seleccionado',
  selected_items: '{length} items seleccionados',
  no_purchase_orders_found: 'No hay órdenes de compras',
  no_bills_found: 'No hay facturas',
  no_payment_complements_found: 'No hay complementos de pago',
  no_related_docs_found: 'No hay documentos relacionados',
  no_result_docs_found: 'No se encontraron documentos',
  no_notifications_found: 'No se encontraron notificaciones',
  user: 'Usuario',
  active: 'Activo',
  inactive: 'Inactivo',
  blocked: 'Bloqueado',
  social_reason: 'Razón Social',
  document_result: 'Resultado documentos',
  unknownFile: 'Archivo desconocido',
  status_historial: 'Estado (historial)',
  pagination_details: 'Mostrando {beginDocs}-{endDocs} / {totalDocs} Resultados',
  relate_documents: 'Relacionar documentos',
  notification_title: 'Notificaciones ({count})',
  view_all_notification: 'Ver todas las notificaciones',
  account_config: 'Configuración de la cuenta',
  edit_profile_photo: 'Editar foto de perfil',
  personal_data: 'Datos personales',
  tax_data: 'Datos fiscales',
  admin_data: 'Datos administrativos',
  phone: 'Teléfono',
  domicile: 'Domicilio',
  postal_code: 'Código Postal',
  save_changes: 'Guardar cambios',
  old_password: 'Contraseña actual',
  new_password: 'Nueva contraseña',
  confirm_password: 'Confirme la contraseña',
  no_passwords_match: 'No coinciden las contraseñas',
  failed_change_password: 'Error el cambiar la contraseña',
  clear_list: 'Borrar lista',
  clean: 'Limpiar',
  new_purchase_order: 'Nueva orden de compra',
  new_satConfig: 'Nueva configuración',
  update_satConfig: 'Editar configuración',
  upload_certifier: 'Subir certificado',
  upload_key: 'Subir llave',
  new_area: 'Nueva área',
  update_area: 'Editar área',
  no_areas_found: 'No hay areas para mostrar',
  new_provider: 'Nuevo proveedor',
  no_providers_found: 'No hay proveedores para mostrar',
  new_profile: 'Nuevo perfil',
  update_profile: 'Editar perfil',
  no_profiles_found: 'No hay perfiles para mostrar',
  new_user: 'Nuevo usuario',
  update_user: 'Editar usuario',
  no_users_found: 'No hay usuarios para mostrar',
  remove_user_confirm_message: '¿Desea eliminar el usuario?',
  remove_user_error_message: 'Error al eliminar el usuario',
  remove_user_confirm_title: 'Eliminar usuario',
  remove_area_confirm_message: '¿Desea eliminar el area?',
  remove_area_error_message: 'Error al eliminar el area',
  remove_area_confirm_title: 'Eliminar area',
  remove_satConfig_confirm_message: '¿Desea eliminar la configuración?',
  remove_satConfig_error_message: 'Error al eliminar la configuración',
  remove_satConfig_confirm_title: 'Eliminar configuración',
  remove_profile_confirm_message: '¿Desea eliminar el perfil?',
  remove_profile_error_message: 'Error al eliminar el perfil',
  remove_profile_confirm_title: 'Eliminar perfil',
  remove_provider_confirm_message:
    '¿Desea eliminar el proveedor <b>{name}</b>? Esta operacion no es reversible',
  remove_provider_error_message: 'Error al eliminar el proveedor',
  remove_provider_confirm_title: 'Eliminar proveedor',
  remove_relationship_confirm_message: '¿Desea eliminar este documento relacionado?',
  remove_relationship_error_message: 'Error al eliminar el documento relacionado',
  remove_relationship_confirm_title: 'Eliminar documento relacionado',
  accept: 'Aceptar',
  cancel: 'Cancelar',
  confirm_code: 'Cambiar contraseña',
  introduce_code: 'Introduzca código de verificación',
  download_pdf: 'Descargar PDF',
  download_xml: 'Descargar XML',
  download_zip: 'Descargar ZIP',
  see_tracking: 'Ver tracking',
  check_sat: 'Revisar estado SAT',
  related_docs: 'Documentos relacionados',
  unrelate_docs: 'Eliminar relación',
  delete: 'Eliminar',
  edit: 'Editar',
  refresh: 'Reiniciar',
  error_inserting_purchase_order: 'Error al insertar la orden de compra',
  save: 'Guardar',
  currentEmail: 'User el correo de esta cuenta',
  roles: 'Roles',
  download_file_link: 'Click aquí para descargar',
  code: 'Código',
  company: 'Empresa',
  loading_start_up: 'Cargando sesión...',
  problem_loading_start_up_data:
    'Ha habido un problema adquiriendo los datos. Probablemente no tenga permisos para acceder a estos información. Debe ponerse en contacto con su administrador de entidad.',
  add_user_success_message: 'El usuario fue añadido satisfactoriamente',
  add_user_failed_message: 'Problemas al añadir el usuario',
  update_user_success_message: 'El usuario fue actualizado satisfactoriamente',
  update_user_failed_message: 'Problemas al actualizar el usuario',
  admin_name: 'Nombre del admin',
  admin_email: 'Email del admin',
  email_exist_already: 'Ya existe un usuario con ese email',
  message: 'Mensaje',
  my_email: 'Enviar a mi correo',
  type: 'Tipo',
  share_report_error: 'Error compartiendo reporte',
  download_massive: 'Descarga masiva',
  massive_download_error_message: 'Problemas al realizar la descarga masiva de documentos',
  massive_download_confirm_title: 'Descargar XMLs',
  massive_download_confirm_message:
    'Usted se dispone a descargar {documents} documentos. ¿Desea continuar?',
  massive_download_confirm_message_no_amount:
    'Usted se dispone a descargar un lote de documentos. ¿Desea continuar?',
  massive_download_success_message:
    'Iniciado satisfactoriamente el proceso de descarga masiva de documentos, le llegará una notificación con los datos para la descarga.',
  massive_download_csv_error_message:
    'Problemas al realizar la descarga de los documentos en formato CSV',
  massive_download_csv_confirm_title: 'Descargar CSV',
  massive_download_csv_confirm_message:
    'Usted se dispone a descargar {documents} documentos en formato CSV. ¿Desea continuar?',
  massive_download_csv_confirm_message_no_amount:
    'Usted se dispone a descargar un lote de documentos en formato CSV. ¿Desea continuar?',
  massive_download_csv_success_message:
    'Iniciado satisfactoriamente el proceso de descarga, le llegará una notificación con los datos para la misma.',
  lot_download_confirm_error_message: 'Problemas al realizar la descarga de los documentos',
  lot_download_confirm_title: 'Descargar lote de documentos',
  lot_download_confirm_message:
    'Usted se dispone a descargar un lote de {documents} documentos. ¿Desea continuar?',
  lot_download_confirm_message_no_amount:
    'Usted se dispone a descargar un lote de documentos. ¿Desea continuar?',
  lot_download_success_message:
    'Iniciado satisfactoriamente el proceso de descarga, le llegará una notificación con los datos para la misma.',
  rfc_error: 'Formato no válido',
  required: 'Campo requerido',
  notification: 'Notificación',
  sat_config: 'Certificados SAT registrados',
  notifications: 'Notificaciones',
  user_created_confim_message: 'Se ha enviado un correo a <b>{email}</b>.',
  password_requirement_1:
    'Longitud mínima, que debe tener un mínimo de 6 caracteres y menos de 99 caracteres',
  password_requirement_2: 'Números obligatorios, requiere un número como mínimo',
  password_requirement_3: 'Un carácter especial obligatorio de este conjunto:',
  password_requirement_4: 'Requiere letras mayúsculas obligatorias',
  password_requirement_5: 'Requiere letras minúsculas obligatorias',
  key: 'Llave',
  create: 'Crear',
  error_title: 'Error',
  create_provider_success_title: 'Usted ha creado un nuevo proveedor para {entity}',
  create_provider_success_message:
    'Le llegaran los detalles y siguientes pasos a seguir por el proveedor a la cuenta <b>{email}</b>',
  preview: 'Vista previa',
  rfcIssuer: 'RFC Emisor',
  rfcReceiver: 'RFC Receptor',
  dateEnd: 'Fecha final',
  dateIn: 'Fecha inicial',
  success_changed_password: 'La contraseña fue cambiada satisfactoriamente',
  users: 'Usuarios',
  companies: 'Compañías',
  new_company: 'Nueva Compañia',
  remove_entity_confirm_message: '¿Está seguro de eliminar esta entidad?',
  remove_entity_confirm_title: 'Eliminar entidad',
  entity_management_area: 'Gestión de áreas en una entidad',
  entity_management_profile: 'Gestión de perfiles en una entidad',
  entity_management_user: 'Gestión de usuarios en una entidad',
  received: 'Recibidos',
  sent: 'Emitidos',
  add: 'Adicionar',
  add_related_document_tooltip: 'Relacionar otros documentos',
  relate: 'Relacionar',
  relate_selected_documents_tooltip: 'Relacionar los documentos seleccionados en la tabla',
  relate_upload_documents_tooltip: 'Agregar otros documentos a la tabla de selección',
  open: 'Abrir',
  dismiss_all: 'Descartar todo',
  company_admin: 'Administración de compañia',
  add_metadata: 'Adicionar Metadata',
  final_doc_stage: 'Estado Final del Flujo',
  verify_exp: 'Exprira Token',
  user_add_metadata_confim_message: 'Se ha añadido Metadata al usuario satisfactoriamente',
  user_created_confirm_without_email:
    'Se envió un mensaje al correo del nuevo usuario, el cual tendrá 7 días para ingresar al sistema y cambiar la contraseña',
  profiles: 'Perfiles',
  provider_created_confirm_without_email:
    'Se envió un mensaje al correo del nuevo proveedor, el cual tendrá 7 días para ingresar al sistema y cambiar la contraseña',
  onboarding: 'Onboarding',
  incorrect_username_or_password: 'Email o contraseña incorrectos',
  welcome_to_carta_porte: 'Bienvenido al Portal de Carta Porte',
  certifier: 'Certificado (.cer)',
  certifier_label: 'Certificado {type} (.cer)',

  dont_account: '¿No tienes una cuenta aún?',
  publicKey: 'Llave (.key)',
  csd: 'CSD',
  efirm: 'FIEL',
  recovery_pass: 'Solicitar código',
  recovery_pass_info: 'Introduzca su correo electrónico o número de teléfono asociado a su cuenta',
  forgot_password_inbox: '¿Olvidaste tu contraseña?',
  info_code: 'Se ha enviado un códogo de verificación a la cuenta registrada',
  request_code: 'Volver a solicitar en',
  email_phone: 'Correo electrónico o teléfono',
  sign_up: '¡Regístrate gratis aquí!',
  new_efirm: 'Nueva fiel',
  new_csd: 'Nuevo CSD',
  update_efirm: 'Editar fiel',
  update_csd: 'Editar CSD',
  change_password_first:
    '¡Bienvenido! empecemos por algunas configuraciones iniciales. Será un proceso muy rápido. Primero, cambia tu contraseña.',
  sign_up_info:
    'Regístrate totalmente gratis y únete a nuestra comunidad de transportistas y embarcadores. ¡En minutos podrás estar generando tu complemento carta porte!',
  join_us: 'Únete',
  user_created_sign_up:
    '¡Bienvenido!. Ya formas parte de nuestra comunidad. Se ha enviado un correo electrónico a la cuenta registrada con una contraseña temporal que deberás cambiar en tu primer ingreso.',
  company_name_placeholder: 'Transportes Flash',
  admin_name_placeholder: 'Juan Pérez',
  admin_email_placeholder: 'johnymove@gmail.com',
  tax_regime: 'Régimen Fiscal',
  tax_record: 'Constancia Fiscal',
  required_changes_for_submit:
    'Es necesario modificar algunos de los datos para poder subir los cambios',
  show_separated_window: 'Ver en ventana ampliada',
  other_data: 'Otros datos',
  rfc_details: 'RFCs registrados, certificados y metadatos',
  force_process: 'Forzar proceso',
  no_match_tax_record_confirm_message1:
    'Una o más validaciones en la constancia fiscal no fueron satisfactorias.',
  no_match_tax_record_confirm_message2:
    'Si está seguro que sus datos son correctos puede IGNORAR este mensaje de error y forzar la carga de los datos.',
  no_match_tax_record_confirm_message3:
    '¿Está seguro que desea subir los datos aunque puedan contener errores? Esto puede ocasionar errores en el timbrado de carta porte.',
  omit: 'Omitir',
  onboardingInfo1: 'Próximamente entrará en vigor la versión 4.0 de CFDI.',
  onboardingInfo2:
    'Esta nueva versión requiere de datos adicionales por lo que deberán subir la siguiente información al sistema.',
  data: 'Datos',
  ignore: 'Ignorar',
  redirect_to_tax_record_video_message:
    'Haz click <a>{text}</a> para obtener información adicional de como descargar la constancia fiscal.',
  here: 'aquí',
  download_format: 'Descargar formato',
  load_data: 'Cargar datos',
  remove_confirmation_default_message: '¿Desea eliminar el elemento actual?',
  next: 'Siguiente',
  add_row: 'Adicionar Fila',
  delete_data_confirmation_message: '¿Está seguro de querer eliminar estos datos?',
  trip_data_confirmation_message: '¿Está seguro que desea eliminar este viaje?',
  location_data_confirmation_message: '¿Está seguro que desea eliminar esta ubicación?',
  goods_data_confirmation_message: '¿Está seguro que desea eliminar esta mercancía?',
  finalize: 'Finalizar',
  document_error: 'Documento con errores',
  cancel_trip: 'Cancelar Viaje',
  confirm_cancel_trip: '¿Está seguro que desea cancelar el viaje?, esta acción es irreversible',
  carrier_assign: 'Transportista Asignado',
  info_carrier_assign:
    'El transportista ya no puede desasignarse, ya que ha completado los campos faltantes requeridos para comenzar el viaje o el viaje ya ha comenzado, si aún así desea desasignarlo debe cancelar el viaje',
  all: 'Todos',
  published_trips: 'Viajes publicados',
  construction_trips: 'Viajes en construcción',
  pending_carrier_fill_trips: 'Pendientes llenado transportista',
  pending_fill_trips: 'Por llenar',
  available_trips: 'Viajes disponibles',
  next_trips: 'Próximos viajes',
  processing: 'En proceso',
  historical: 'Históricos',
  PENDING: 'Pendiente',
  CONCLUDED: 'Concluido',
  WITH_KNOWN_ERROR: 'Error Conocido',
  WITH_UNKNOWN_ERROR: 'Error Desconocido',
  INTERRUPTED: 'Interrumpido',
  IN_PROCESS: 'En Proceso',
  TRAVEL_PLANNING: 'Planeación',
  TRAVEL_DOCUMENTATION: 'Documentación',
  TRAVEL_EXECUTION: 'Ejecución',
  TRAVEL_REVIEW: 'Calificación',
  TRAVEL_PAYMENT: 'Facturación',
  TRAVEL_CANCELLATION: 'Cancelación',
  TRAVEL_EDITION: 'Edición',
  with_third_parties: 'Con terceros',
  my_trips: 'Mis Viajes',
  trips: 'Viajes',
  interested: 'Me interesa',
  not_interested: 'No me interesa',
  catalogs: 'Catálogos',
  units: 'Unidades',
  findUnits: 'Buscar Unidad',
  new_unit: 'Nueva Unidad',
  edit_unit: 'Editar Unidad',
  delete_unit: 'Eliminar Unidad',
  confirm_delete_unit: '¿Está seguro que desea eliminar la unidad?',
  trailers: 'Remolques',
  findTrailers: 'Buscar Remolque',
  new_trailer: 'Nuevo Remolque',
  edit_trailer: 'Editar Remolque',
  delete_trailer: 'Eliminar Remolque',
  confirm_delete_trailer: '¿Está seguro que desea eliminar el remolque?',
  operators: 'Operadores',
  findOperators: 'Buscar Operador',
  new_operator: 'Nuevo Operador',
  edit_operator: 'Editar Operador',
  delete_operator: 'Eliminar Operador',
  confirm_delete_operator: '¿Está seguro que desea eliminar el operador?',
  locations: 'Ubicaciones',
  findLocations: 'Buscar Ubicaciones',
  new_location: 'Nueva Ubicación',
  edit_location: 'Editar Ubicación',
  delete_location: 'Eliminar Ubicación',
  confirm_delete_location: '¿Está seguro que desea eliminar la ubicación?',
  merchandises: 'Mercancías',
  commodity: 'Mercancía',
  findMerchandise: 'Buscar Mercancía',
  new_merchandise: 'Nueva Mercancía',
  edit_merchandise: 'Editar Mercancía',
  delete_merchandise: 'Eliminar Mercancía',
  confirm_delete_merchandise: '¿Está seguro que desea eliminar la mercancía?',
  carriers: 'Transportistas',
  carrier: 'Transportista',
  findCarrier: 'Buscar Transportista',
  new_carrier: 'Nuevo Transportista',
  edit_carrier: 'Editar Transportista',
  delete_carrier: 'Eliminar Transportista',
  confirm_delete_carrier: '¿Está seguro que desea eliminar el transportista?',
  confirm_delete_client: '¿Está seguro que desea eliminar el cliente?',
  delete_client: 'Eliminar Cliente',
  client: 'Cliente',
  vehicle_configuration: 'Configuración Vehicular',
  post_trip: 'Publicar Viaje',
  trip: 'Viaje',
  billing: 'Facturación',
  created_message: '{element} creado satisfactoriamente',
  updated_message: '{element} actualizado satisfactoriamente',
  removed_message: '{element} eliminado satisfactoriamente',
  and: 'y',
  carrier_success_trip_create_message: 'Documento enviado a emitir',
  minutes: 'Minutos',
  location: 'Ubicación',
  confirm_delete_company: '¿Está seguro que desea eliminar la compañia?',
  back: 'Atrás',
  Desconocido: 'Estado del viaje desconocido',
  tripCancelled: 'El viaje fue concluido.',
  tripConcluded:
    'El viaje fue concluido. Por favor, haz una evaluación y reseña de tu viaje. Tu retroalimentación ayuda a mantener nuestra comunidad.',
  tripExecution:
    'El viaje está en ejecución. Puedes ver la ubicación en tiempo real de la unidad en la vista de Detalles del Viaje (clic sobre la celda del viaje).',
  tripReady:
    'Todo está listo para tu viaje, solo estamos a la espera de que llegue el momento de iniciarlo.',
  tripWithError:
    'Ha ocurrido un error generando la carta porte de su viaje. Revise el mensaje de error e intente corregir los datos erróneos. Su viaje no puede comenzar sin la carta porte.',
  tripDocumenting:
    'Ya casi está listo el viaje. Contamos con toda la información necesaria y se está generando la carta porte.',
  tripCarrierAssigned:
    'Ya le asignaste un transportista a tu viaje. Está pendiente que el transportista le asigne una unidad y operador.',
  tripPublished:
    'El viaje ya está publicado y los transportistas pueden interesarse en él. Una vez que el viaje tenga transportistas interesados puedes asignarle uno.',
  tripPlanning:
    'Aún no concluyes el proceso de creación de tu viaje porque no has introducido todos los datos necesarios. El viaje aún no es visible por los transportistas. Haz clic en editar para completar y publicar el viaje.',
};
